module.exports = __webpack_public_path__ + "static/img/index19.a23695d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index19.gif
// module id = 1sin
// module chunks = 0